<template>
  <div class="scene-guide">
    <div class="back-button" @click="onBack">
      <img src="/images/game/back.png" />
    </div>
    <div class="title">
      <img src="/images/game/guide-title.png" />
    </div>
    <div class="toggle-button">
      <div class="video-on" v-if="videoON">
        <img src="/images/game/video-on.png" @click="onClick(true)" />
        <img src="/images/game/text-off.png" @click="onClick(false)" />
      </div>
      <div class="video-off" v-else>
        <img src="/images/game/video-off.png" @click="onClick(true)" />
        <img src="/images/game/text-on.png" @click="onClick(false)" />
      </div>
    </div>
    <div class="content">
      <video src="/video/guide.mp4" v-if="videoON" controls autoplay></video>
      <img src="/images/game/guide-text.png" v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideScene",
  data() {
    return {
      videoON: true
    };
  },
  methods: {
    onClick(bool) {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.videoON = bool;
    },
    onBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    }
  }
};
</script>


<style lang="scss" scoped>
.scene-guide {
  width: 1100px;
  height: 560px;
  position: relative;

  background: linear-gradient(
    180deg,
    rgba(96, 66, 11, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );

  .back-button {
    position: absolute;
    width: 80px;
    height: 40px;
    cursor: pointer;

    img {
      width: 100%;
    }

    img:hover {
      box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
    }
  }

  .title {
    position: absolute;
    top: 39px;
    left: 329px;
    width: 442px;
    height: 50px;

    img {
      width: 100%;
    }
  }

  .toggle-button {
    position: absolute;
    top: 104px;
    left: 440px;
    width: 220px;
    height: 30px;

    cursor: pointer;

    img {
      height: 30px;
    }
  }

  .content {
    position: absolute;

    video {
      position: absolute;
      top: 152px;
      left: 210px;

      width: 680px;

      border: 1px solid #dbc8a1;
    }

    img {
      position: absolute;
      top: 156px;
      left: 220px;

      width: 660px;
    }
  }
}
</style>